module.exports = __webpack_public_path__ + "static/838127738.50139fad.jpg";